import omit from 'lodash/omit';

import { ICoverageConfig } from '../../interfaces/auto';
import coverageKeys from '../constants/coverageKeys';

function buildCoverageConfig(coverageConfig: ICoverageConfig) {
  return (
    coverageConfigOverrides?: Partial<Omit<ICoverageConfig, 'key'>>
  ): ICoverageConfig => ({
    ...coverageConfig,
    ...omit(coverageConfigOverrides, ['key']),
  });
}

const coverageConfigs: Record<
  string,
  ReturnType<typeof buildCoverageConfig>
> = {
  ADDITIONAL_EQUIPMENT: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.ADDITIONAL_EQUIPMENT,
    value_type: 'string',
  }),
  BODILY_INJURY_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.BODILY_INJURY_LIMIT,
    value_type: 'string',
  }),
  COLLISION_DEDUCTIBLE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.COLLISION_DEDUCTIBLE,
    value_type: 'string',
  }),
  COLLISION_DEDUCTIBLE_WAIVER: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: false,
    key: coverageKeys.COLLISION_DEDUCTIBLE_WAIVER,
    value_type: 'boolean',
  }),
  COMPREHENSIVE_DEDUCTIBLE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.COMPREHENSIVE_DEDUCTIBLE,
    value_type: 'string',
  }),
  GAP: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.GAP,
    value_type: 'boolean',
  }),
  GLASS: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.GLASS,
    value_type: 'boolean',
  }),
  LOAN_LEASE_PAYOFF: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.LOAN_LEASE_PAYOFF,
    value_type: 'boolean',
  }),
  LOSS_OF_USE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.LOSS_OF_USE,
    value_type: 'string',
  }),
  MEDICAL_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.MEDICAL_LIMIT,
    value_type: 'string',
  }),
  NEW_CAR_REPLACEMENT: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.NEW_CAR_REPLACEMENT,
    value_type: 'boolean',
  }),
  OEM_PARTS: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.OEM_PARTS,
    value_type: 'boolean',
  }),
  PERSONAL_INJURY_PROTECTION_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.PERSONAL_INJURY_PROTECTION_LIMIT,
    value_type: 'string',
  }),
  PET_PASSENGER: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.PET_PASSENGER,
    value_type: 'boolean',
  }),
  PROPERTY_DAMAGE_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.PROPERTY_DAMAGE_LIMIT,
    value_type: 'string',
  }),
  RENTAL_REIMBURSEMENT: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.RENTAL_REIMBURSEMENT,
    value_type: 'string',
  }),
  RIDESHARING: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.RIDESHARING,
    value_type: 'boolean',
  }),
  ROADSIDE_ASSISTANCE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.ROADSIDE_ASSISTANCE,
    value_type: 'boolean',
  }),
  SIDE_HUSTLE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.SIDE_HUSTLE,
    value_type: 'boolean',
  }),
  TEMPORARY_RIDE: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.TEMPORARY_RIDE,
    value_type: 'string',
  }),
  TOWING_ROAD_SERVICES: buildCoverageConfig({
    appliesTo: 'VEHICLE',
    default_value: null,
    key: coverageKeys.TOWING_ROAD_SERVICES,
    value_type: 'boolean',
  }),
  UNDERINSURED_MOTORIST_BODILY_INJURY_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.UNDERINSURED_MOTORIST_BODILY_INJURY_LIMIT,
    value_type: 'string',
  }),
  UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT,
    value_type: 'string',
  }),
  UNINSURED_MOTORIST_BODILY_INJURY_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.UNINSURED_MOTORIST_BODILY_INJURY_LIMIT,
    value_type: 'string',
  }),
  UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT: buildCoverageConfig({
    appliesTo: 'POLICY',
    default_value: null,
    key: coverageKeys.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT,
    value_type: 'string',
  }),
};

export default coverageConfigs;
